export const HoustonData = [
  {
    title: "Technical",
    detail:
      "For technical translations necessary for highly specialized businesses, Tomedes' translators are industry experts. They know how to translate technical terminologies within technical fields. They're technical writers, technical translators, and technical post-editors. They're versed with the fields.",
    link: "/technical-translation.php",
    subTitle: "Translation Services",
  },
  {
    title: "Legal ",
    detail:
      "Legal translation services are necessary for all fields of law: constitutional, corporate, intellectual property, environmental law and more. Legal translations must be done by legal translators--thus Tomedes is highly equipped to do so, with our large network of translators.",
    link: "/legal-translation.php",
    subTitle: "Translation Services",
  },
  {
    title: "Document",
    detail:
      "Don't go looking for document translation services aside from Tomedes. Documents translated by Tomedes accurately represent the original, and our ATA certifications will make sure of it. For applications in universities and the USCIS, we can translate your transcripts, birth certificates, and other essential documents.",
    link: "/document-translation-services",
    subTitle: "Translation Services",
  },
  {
    title: "Medical ",
    detail:
      "Translation, interpretation, and transcription is essential to the medical field. With Tomedes' medical interpreters, medical transcriptionists, and medical translators, you can make sure your patients' needs are 100% taken care of, no matter what language they speak.",
    link: "/medical-translation.php",
    subTitle: "Translation Services",
  },
  {
    title: "Marketing",
    detail:
      "For all your relevant marketing and advertising needs, Tomedes can provide you with highly specialized industry standards. Our multilingual SEO experts, marketing localizers, and advertising translators can build multilingual websites, content, and branding for your business.",
    link: "/marketing-translation.php",
    subTitle: "Translation Services",
  },
  {
    title: "Interpreting ",
    detail:
      "Tomedes' Houston interpreters can level the playing field through new technologies in the field. Whether you need simultaneous, consecutive, or any other types of interpreting services, Tomedes has the right service for you. Don't hesitate to ask.",
    link: "/interpretation-services",
    subTitle: "Services",
  },
];

export const LanguagesInHouston = [
  {
    heading: "Spanish",
    detail:
      "There are 1.3 million people who speak Spanish in Houston, Texas, so translations may be a necessity for communications from English or any other language to Spanish, and vice versa. That's why our language pairs for Spanish are so varied. Get started today, and start accessing those 1.3 million Spanish speakers.",
    link: "/spanish-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Russian ",
    detail:
      "An astounding 60,000 people speak Russian in Houston alone. That means that translation services will be ultimately useful for Russian speakers in Houston as well as businesses looking to branch into Houston. If you're looking to translate from any of our other languages into Russian, or vice versa, you can contact us now.",
    link: "/russian-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Chinese",
    detail:
      "The third most-spoken language in Houston is Chinese, spoken by 40,000 people in Houston, Texas. As a language of business, Chinese may be a necessary language for you. If it is, get in touch with Tomedes Chinese translators now, who can translate from English to Chinese and Chinese to English.",
    link: "/mandarin-chinese-translation",
    secondHeading: "Translation Services",
  },
  {
    heading: "Korean",
    detail:
      "The impact of the Korean language on popular culture worldwide is not to be underestimated. That's also why it's a popular language in Houston, and why translation services are fully equipped to deliver Korean translation services. If you're looking at the Korean language for business or individual needs, contact us today.",
    link: "/korean-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Arabic",
    detail:
      "Arabic is one of the oldest languages in the world, and spoken by Houston residents majorly as well. Tomedes can fully deliver Arabic translations for you or your business to expand in Houston or globally. Partner with Tomedes today, and see the growth you can bring to your business.",
    link: "/arabic-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Portuguese",
    detail:
      "Portuguese is another most commonly spoken language in Houston, and spoken by about 220 million worldwide. Portuguese is spoken in wide-ranging parts of the world. Portuguese can be paired with English, Spanish, or any other language for translation. Just ask Tomedes, who are experts in language translation.",
    link: "/portuguese-translation.php",
    secondHeading: "Translation Services",
  },
];
